module.exports = __webpack_public_path__ + "img/glassquality_1.be37251b.png";